import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedUploadVersionButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedUploadVersionButton = useCallback(() => {
    track(`Clicked upload version button`);
  }, [track]);

  return { trackClickedUploadVersionButton };
};
